import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", role: "img" }, props, { children: _jsx("path", { fill: "currentColor", d: "M21.033 18 12 9.64 2.967 18 1 16.18 12 6l11 10.18L21.033 18Z" }) })));
export default SvgChevronUp;
